import React from "react"
import { withRouter } from "next/router"

class Redirect extends React.Component {
  componentDidMount = () => {
    this.props.router.push(this.props.to)
  }
  render() {return<></>}
}

export default withRouter(Redirect)